module.exports = __webpack_public_path__ + "media/images/img-free-online-consultation-61f45373.jpg";